import { AxiosError } from 'axios';



import { secureStorage } from '@/lib/storage-client/storage.ts';
import { Notification, notificationsAtom } from '@/state/notifications.ts';
import { store } from '@/state/store.ts';


export interface ApiError {
  message: string;
  code?: string;
  status?: number;
  errors?: Record<string, string[]>;
}

export async function handleResponseError(error: AxiosError, clientName: string): Promise<never> {
  const { message, status, code, response } = error;
  const setNotification = (notification: Notification) => {
    store.set(notificationsAtom, notification);
  };

  function addNotification(notification: Notification) {
    setNotification(notification);
  }
  let apiError: ApiError = {
    message: message,
    status: response?.status || status,
    code,
  };
  // Handle specific status codes
  switch (status) {
    case 401: {
      // Redirect to login page with current location as redirect target
      const currentPath = window.location.pathname + window.location.search;
      const loginUrl =
        currentPath !== '/' ? `/?redirectTo=${encodeURIComponent(currentPath)}` : '/';

      if (!['/login', '/', '/verify'].includes(window.location.pathname)) {
        // Unauthorized - clear session and redirect to login
        secureStorage.clearSession();
        // Use replace to avoid back button issues
        window.location.replace(loginUrl);
      }
      break;
    }

    case 500:
      addNotification({
        type: 'error',
        title: 'Server Error',
        message: 'Ein Fehler ist aufgetreten. Bitte versuche es später noch einmal.',
      });
      break;

  }

  console.error(`${clientName} API Error:`, apiError);
  throw apiError;
}
